import { Tiptap } from './components/editor';
import { Label } from '@src/design-system/label';

import type { ComponentProps } from 'react';

type TiptapEditorProps = {
  label?: string;
  name?: string;
  className?: string;
  labelProps?: ComponentProps<typeof Label>;
  borderColor?: string;
  helperText?: string | boolean;
  errorText?: string;
  error?: boolean;
  isPending?: boolean;
  value: string;
} & Omit<ComponentProps<typeof Tiptap>, 'content'>;

export const TiptapEditor: React.FC<TiptapEditorProps> = ({
  label,
  className,
  labelProps,
  helperText,
  errorText,
  error,
  value,
  ...props
}) => {
  return (
    <div className={className}>
      {label && <Label {...labelProps}>{label}</Label>}

      <Tiptap
        content={value}
        {...props}
      />

      {(helperText || errorText || error) && (
        <p className='text-red-500 text-sm my-1'>{helperText || errorText}</p>
      )}
    </div>
  );
};
